// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host ::ng-deep .myDiagramDiv {
  background: white;
  width: 100%;
  height: 400px;
  /*box-shadow: rgba(0, 0, 0, 0.12) 0px 5px 15px 0px;*/
  border-radius:20px;
}



:host ::ng-deep .myPalleteDiv {
  background: white;
  width: 100%;
  height: 400px;
  /*box-shadow: rgba(0, 0, 0, 0.12) 0px 5px 15px 0px;*/
  border-radius:20px;
}


.myDiagramDiv {
  background: whitesmoke;
  width: 700px;
  height: 300px;
  border: 1px solid black;
}

.myPaletteDiv {
  background: lightcyan;
  border: 1px solid navy;
  width: 125px;
  height: 300px;
}

.myOverviewDiv {
  width: 200px;
  height: 150px;
  background: whitesmoke;
  border: 1px solid black;
}

.left {
  float: left;
  padding: 5px;
  margin: 5px;
}

.box {
  border: solid 1px black;
  background: whitesmoke;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
}

.clear {
  clear: both;
}

/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImxpYnJhcnktY29tcG9uZW50LmNzcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQTtFQUNFLGlCQUFpQjtFQUNqQixXQUFXO0VBQ1gsYUFBYTtFQUNiLG9EQUFvRDtFQUNwRCxrQkFBa0I7QUFDcEI7Ozs7QUFJQTtFQUNFLGlCQUFpQjtFQUNqQixXQUFXO0VBQ1gsYUFBYTtFQUNiLG9EQUFvRDtFQUNwRCxrQkFBa0I7QUFDcEI7OztBQUdBO0VBQ0Usc0JBQXNCO0VBQ3RCLFlBQVk7RUFDWixhQUFhO0VBQ2IsdUJBQXVCO0FBQ3pCOztBQUVBO0VBQ0UscUJBQXFCO0VBQ3JCLHNCQUFzQjtFQUN0QixZQUFZO0VBQ1osYUFBYTtBQUNmOztBQUVBO0VBQ0UsWUFBWTtFQUNaLGFBQWE7RUFDYixzQkFBc0I7RUFDdEIsdUJBQXVCO0FBQ3pCOztBQUVBO0VBQ0UsV0FBVztFQUNYLFlBQVk7RUFDWixXQUFXO0FBQ2I7O0FBRUE7RUFDRSx1QkFBdUI7RUFDdkIsc0JBQXNCO0VBQ3RCLDRFQUE0RTtBQUM5RTs7QUFFQTtFQUNFLFdBQVc7QUFDYiIsImZpbGUiOiJsaWJyYXJ5LWNvbXBvbmVudC5jc3MiLCJzb3VyY2VzQ29udGVudCI6WyI6aG9zdCA6Om5nLWRlZXAgLm15RGlhZ3JhbURpdiB7XG4gIGJhY2tncm91bmQ6IHdoaXRlO1xuICB3aWR0aDogMTAwJTtcbiAgaGVpZ2h0OiA0MDBweDtcbiAgLypib3gtc2hhZG93OiByZ2JhKDAsIDAsIDAsIDAuMTIpIDBweCA1cHggMTVweCAwcHg7Ki9cbiAgYm9yZGVyLXJhZGl1czoyMHB4O1xufVxuXG5cblxuOmhvc3QgOjpuZy1kZWVwIC5teVBhbGxldGVEaXYge1xuICBiYWNrZ3JvdW5kOiB3aGl0ZTtcbiAgd2lkdGg6IDEwMCU7XG4gIGhlaWdodDogNDAwcHg7XG4gIC8qYm94LXNoYWRvdzogcmdiYSgwLCAwLCAwLCAwLjEyKSAwcHggNXB4IDE1cHggMHB4OyovXG4gIGJvcmRlci1yYWRpdXM6MjBweDtcbn1cblxuXG4ubXlEaWFncmFtRGl2IHtcbiAgYmFja2dyb3VuZDogd2hpdGVzbW9rZTtcbiAgd2lkdGg6IDcwMHB4O1xuICBoZWlnaHQ6IDMwMHB4O1xuICBib3JkZXI6IDFweCBzb2xpZCBibGFjaztcbn1cblxuLm15UGFsZXR0ZURpdiB7XG4gIGJhY2tncm91bmQ6IGxpZ2h0Y3lhbjtcbiAgYm9yZGVyOiAxcHggc29saWQgbmF2eTtcbiAgd2lkdGg6IDEyNXB4O1xuICBoZWlnaHQ6IDMwMHB4O1xufVxuXG4ubXlPdmVydmlld0RpdiB7XG4gIHdpZHRoOiAyMDBweDtcbiAgaGVpZ2h0OiAxNTBweDtcbiAgYmFja2dyb3VuZDogd2hpdGVzbW9rZTtcbiAgYm9yZGVyOiAxcHggc29saWQgYmxhY2s7XG59XG5cbi5sZWZ0IHtcbiAgZmxvYXQ6IGxlZnQ7XG4gIHBhZGRpbmc6IDVweDtcbiAgbWFyZ2luOiA1cHg7XG59XG5cbi5ib3gge1xuICBib3JkZXI6IHNvbGlkIDFweCBibGFjaztcbiAgYmFja2dyb3VuZDogd2hpdGVzbW9rZTtcbiAgYm94LXNoYWRvdzogMCA0cHggOHB4IDAgcmdiYSgwLCAwLCAwLCAwLjIpLCAwIDZweCAyMHB4IDAgcmdiYSgwLCAwLCAwLCAwLjE5KTtcbn1cblxuLmNsZWFyIHtcbiAgY2xlYXI6IGJvdGg7XG59XG4iXX0= */`, "",{"version":3,"sources":["webpack://./src/app/containers/ticketing/components/projects/library-component/library-component.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,WAAW;EACX,aAAa;EACb,oDAAoD;EACpD,kBAAkB;AACpB;;;;AAIA;EACE,iBAAiB;EACjB,WAAW;EACX,aAAa;EACb,oDAAoD;EACpD,kBAAkB;AACpB;;;AAGA;EACE,sBAAsB;EACtB,YAAY;EACZ,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;EACtB,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,uBAAuB;EACvB,sBAAsB;EACtB,4EAA4E;AAC9E;;AAEA;EACE,WAAW;AACb;;AAEA,4+DAA4+D","sourcesContent":[":host ::ng-deep .myDiagramDiv {\n  background: white;\n  width: 100%;\n  height: 400px;\n  /*box-shadow: rgba(0, 0, 0, 0.12) 0px 5px 15px 0px;*/\n  border-radius:20px;\n}\n\n\n\n:host ::ng-deep .myPalleteDiv {\n  background: white;\n  width: 100%;\n  height: 400px;\n  /*box-shadow: rgba(0, 0, 0, 0.12) 0px 5px 15px 0px;*/\n  border-radius:20px;\n}\n\n\n.myDiagramDiv {\n  background: whitesmoke;\n  width: 700px;\n  height: 300px;\n  border: 1px solid black;\n}\n\n.myPaletteDiv {\n  background: lightcyan;\n  border: 1px solid navy;\n  width: 125px;\n  height: 300px;\n}\n\n.myOverviewDiv {\n  width: 200px;\n  height: 150px;\n  background: whitesmoke;\n  border: 1px solid black;\n}\n\n.left {\n  float: left;\n  padding: 5px;\n  margin: 5px;\n}\n\n.box {\n  border: solid 1px black;\n  background: whitesmoke;\n  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);\n}\n\n.clear {\n  clear: both;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
